import request from './api';
import {
  API_DEPARTMENT,
  API_LOCATIONS,
  API_POSITION,
  API_GROUPS
} from '../constants/api';

export const getDepartments = () =>
  request(`${API_DEPARTMENT}`, {
    method: 'GET'
  });

export const getSubDepartments = id =>
  request(`${API_DEPARTMENT}/${id}/childrens`, {
    method: 'GET'
  });

export const getAreas = id =>
  request(`${API_DEPARTMENT}/${id}/childrens`, {
    method: 'GET'
  });

export const getLocations = () =>
  request(`${API_LOCATIONS}`, {
    method: 'GET'
  });

export const getUserPosition = () =>
  request(`${API_POSITION}`, {
    method: 'GET'
  });

export const getLanguages = () =>
  request(`${API_GROUPS}languages`, {
    method: 'GET'
  });

export const getConsultants = () =>
  request(`${API_GROUPS}partnerCompanies`, {
    method: 'GET'
  });

export const getSkills = () =>
  request(`${API_GROUPS}skills`, {
    method: 'GET'
  });

export const getHobbyCategories = () =>
  request(`${API_GROUPS}hobbies`, {
    method: 'GET'
  });

export const getHobbiesByCat = catId =>
  request(`${API_GROUPS}hobbies/${catId}`, {
    method: 'GET'
  });

export const getEducationsCategory1 = () =>
  request(`${API_GROUPS}educationsCategory1`, {
    method: 'GET'
  });

export const getEducationsCategory2 = id =>
  request(`${API_GROUPS}educationsCategory2?categoryId1=${id}`, {
    method: 'GET'
  });

export const getEducationsCategory3 = id =>
  request(`${API_GROUPS}educationsCategory3?categoryId2=${id}`, {
    method: 'GET'
  });
